import { render, staticRenderFns } from "./match-list.vue?vue&type=template&id=08777b84&scoped=true&"
import script from "./match-list.vue?vue&type=script&lang=js&"
export * from "./match-list.vue?vue&type=script&lang=js&"
import style0 from "./match-list.vue?vue&type=style&index=0&id=08777b84&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08777b84",
  null
  
)

export default component.exports